import Icon from '@kurtosys/ksys-app-components/dist/components/base/Icon';
import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';

export default InjectedStyledComponent(Icon, 'feedback', ['icon']);
